/**
 * Created by Ning Jiang on 10/10/2018.
 */

import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {LoaderEvent} from "@nolimitcity/slot-game/bin/core/resource/event/LoaderEvent";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {InitialWinPresentationController} from "@nolimitcity/slot-game/bin/game/winpresentation/initial/InitialWinPresentationController";
import {Linear, Power1, TimelineLite, TweenLite} from "gsap";
import {CreepyCarnivalBetLineEvent} from "../../betline/CCTwoBetlinesView";
import {CreepyCarnivalTwoGameConfig} from "../../CreepyCarnivalTwoGameConfig";
import {CreepyCarnivalTwoSoundConfig} from "../../CreepyCarnivalTwoSoundConfig";
import {CCTwoMultiplierEvents} from "../../multiplier/CCTwoMultiplierEvents";
import {CreepyCarnivalTwoParsedGameData} from "../../server/data/CreepyCarnivalTwoParsedGameData";
import {CreepyCarnivalTwoParsedInitData} from "../../server/data/CreepyCarnivalTwoParsedInitData";
import {CCTwoStarSpinIntroEvents} from "../../starspin/controller/StarSpinIntroController";
import {CCTwoHelper} from "../../utils/CCTwoHelper";
import {CreepyCarnivalTwoInitialWinCountUp} from "./CreepyCarnivalTwoInitialWinCountUp";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";

export class CCTwoInitialWPEvents {
    public static readonly STAR_ANIMATION_COMPLETED:string = "CCTwoInitialWP_STAR_ANIMATION_COMPLETED";
    public static readonly WIN_PRESENTATION_ABORTED:string = "CCTwoInitialWP_WIN_PRESENTATION_ABORTED";
    public static readonly DISPLAY_STATUS_SCREEN:string = "CCTwoInitialWP_DISPLAY_STATUS_SCREEN";
    public static readonly STAR_STATUS_SCREEN_HIDDEN:string = "CCTwoInitialWP_STAR_STATUS_SCREEN_HIDDEN";
    public static readonly HIDE_STATUS_SCREEN:string = "CCTwoInitialWP_HIDE_STATUS_SCREEN";
    public static readonly DISPLAY_STAR_SPIN_LOGO:string = "CCTwoInitialWP_DISPLAY_STAR_SPIN_LOGO";
    public static readonly DISPLAY_STAR_SPIN_BULBS_AT_ONCE:string = "CCTwoInitialWP_DISPLAY_STAR_SPIN_BULBS_AT_ONCE";
    public static readonly CHANGE_BET_FOR_STAR_SPIN:string = "CCTwoInitialWP_CHANGE_BET_FOR_STAR_SPIN";
}

export class CreepyCarnivalTwoInitialWPController extends InitialWinPresentationController {

    public _highSym:Array<string> = [];
    protected _noWinSymbols:StateReelSymbol[] = [];
    private _winCountUp:CreepyCarnivalTwoInitialWinCountUp;
    private _symbolWinStates:boolean[][];
    private _allStarCollected:boolean = false;
    private _layer:ScalableLayer;
    private _betLineWinData:IBetLineWinData[];
    private readonly HIGH_WIN_SYMS:string[] = ["M1", "M2", "M3", "M4", "M5"];
    private readonly _container:PIXI.Container;
    private _img:PIXI.Sprite;
    private _multiplier:number = 1;
    private _counter:number = 0;
    private _mode:string;
    private _winTimelineAdded:boolean = false;
    private _lineAnimDelay:number[] = [];//[0, 0.3, 0.2];
    private _defaultLineAnimDelay:number = 0.05;
    private _toggleWinDuration:number[] = [0.3, 0.2, 0.15];
    private _targetCounter:number = 0;
    private _animItems:PIXI.Sprite[] = [];
    private _winTl:TimelineLite | null;

    private _winBelowStake: boolean = false;

    constructor(indexes:[number, number]) {
        super(indexes);

        let item:PIXI.Sprite;

        this._winCountUp = new CreepyCarnivalTwoInitialWinCountUp();
        this._winCountUp.position.set(GameConfig.instance.GAME_WIDTH * 0.5, GameConfig.instance.GAME_HEIGHT * 0.5);
        this._layer = StageManager.getLayer(CreepyCarnivalTwoGameConfig.instance.LAYERS.WIN_PRESENTATIONS.name);
        StageManager.getLayer(CreepyCarnivalTwoGameConfig.instance.LAYERS.WIN_COUNT_UP.name).addChild(this._winCountUp);

        this._container = new PIXI.Container();
        StageManager.getLayer(CreepyCarnivalTwoGameConfig.instance.LAYERS.STAR.name).addChild(this._container);

        this._layer = StageManager.getLayer(CreepyCarnivalTwoGameConfig.instance.LAYERS.SYMBOLS_ANIMATION.name);
        for(let i:number = 0; i < CreepyCarnivalTwoGameConfig.instance.REELS_NUM; ++i) {
            item = new PIXI.Sprite();
            item.anchor.set(0.5);
            item.visible = false;

            this._animItems[i] = item;

            this._layer.addChild(item);
        }
    }

    protected addFeatureEventHandlers():void {
        super.addFeatureEventHandlers && super.addFeatureEventHandlers();

        EventHandler.addEventListener(this, LoaderEvent.RESOURCES_LOADED, (event:LoaderEvent) => this.onInitResourcesLoaded(event));
        EventHandler.addEventListener(this, SpinEvent.IDLE, () => this.onIdle());
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.parseInitGameData(event.params[0]));
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, () => this.onBeforeSpinStart());
    }

    private onIdle():void {
        EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));
        this.onBeforeSpinStart();
    }

    protected addWinAnimationsToTimeline(timeline:TimelineLite):void {
        this._targetCounter = -1;

        if(GameSetting.isFastSpin) {
            // #323
            timeline.add(this.showBetlineAmountInitialWin(this._betLineWinData), 0);

            this._winTimelineAdded = false;
            EventHandler.dispatchEvent(new GameEvent(CreepyCarnivalBetLineEvent.SHOW_ALL_MAIN_BET_LINES, this._betLineWinData));

            for(let i:number = 0; i < this._betLineWinData.length; ++i) {

                let sym:string = this._betLineWinData[i].symbol;
                if((this._multiplier !== 5) && (this._counter < 13) && this._mode !== "STAR_SPIN") {
                    if(this.HIGH_WIN_SYMS.indexOf(sym) !== -1) {
                        this._counter++;
                        EventHandler.dispatchEvent(new GameEvent(CCTwoInitialWPEvents.STAR_ANIMATION_COMPLETED));
                    }
                }
            }
        } else {
            this._winTimelineAdded = true;
            this._targetCounter = this._counter;

            let winLength:number = this._betLineWinData.length;
            if(winLength > 4) {
                winLength = 4;
            }

            let lastTimelineDuration:number = 0;

            for(let i:number = 0; i < winLength; ++i) {
                let winTimeLine:TimelineLite = new TimelineLite(),
                    isStarVisible:boolean;

                winTimeLine.add(() => {
                    EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));
                    EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SHOW_WIN_BET_LINE, this._betLineWinData[i].betLineIndex + 1));

                    // #312
                    if (!this._winBelowStake) {
                        SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.BET_LINE_SOUND);
                    }
                }, 0);
                winTimeLine.add(this.playSymbolAnimation(this._betLineWinData[i], i, this._betLineWinData.length), 0);
                if(!GameSetting.isFastSpin) {
                    isStarVisible = (this._mode.indexOf("FREESPIN") < 0 && this._counter < 13 && this._betLineWinData[i].symbol.indexOf("L") < 0);

                    let sym:string = this._betLineWinData[i].symbol;
                    if((this._multiplier !== 5) && (this._counter < 13) && this._mode !== "STAR_SPIN") {
                        if(this.HIGH_WIN_SYMS.indexOf(sym) !== -1) {
                            this._targetCounter++;
                        }
                    }

                    winTimeLine.add(this.playStarAnimation({
                        betLineData : this._betLineWinData[i],
                        index : i,
                        winLength : this._betLineWinData.length,
                        isStarVisible : isStarVisible
                    }), 0);
                }
                if(i == winLength - 1) {
                    lastTimelineDuration = winTimeLine.totalDuration();
                }

                // #323
                if (i === 0) {
                    winTimeLine.add(this.showBetlineAmountInitialWin(this._betLineWinData), 0);
                }

                timeline.add(winTimeLine);
            }

            for(let i:number = winLength; i < this._betLineWinData.length; ++i) {
                let winTimeLine = new TimelineLite();
                let delay:number = this._toggleWinDuration[this._toggleWinDuration.length - 1];
                if((i - winLength) < (this._toggleWinDuration.length - 1)) {
                    delay = this._toggleWinDuration[(i - winLength)];
                }

                let isTargetUpRequired:boolean = false;
                let sym:string = this._betLineWinData[i].symbol;

                if((this._multiplier !== 5) && (this._counter < 13) && this._mode !== "STAR_SPIN") {
                    if(this.HIGH_WIN_SYMS.indexOf(sym) !== -1 && this._targetCounter < 13) {
                        isTargetUpRequired = true;
                        this._targetCounter++;
                    }
                }

                winTimeLine.add(() => {
                    this._winTimelineAdded = false;
                    if(i === winLength) {
                        EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));
                    }

                    // #312
                    if (!this._winBelowStake) {
                        SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.BET_LINE_SOUND);
                    }
                    EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SHOW_WIN_BET_LINE, this._betLineWinData[i].betLineIndex + 1));

                    if(isTargetUpRequired) {
                        this._counter++;
                        EventHandler.dispatchEvent(new GameEvent(CCTwoInitialWPEvents.STAR_ANIMATION_COMPLETED, true));
                        if(this._targetCounter === 13) {
                            // this._targetCounter = 0;
                            isTargetUpRequired = false;
                        }
                    }
                }, delay);

                timeline.add(winTimeLine);
            }

            if(this._betLineWinData.length > 4) {
                let winTimeLine = new TimelineLite();
                winTimeLine.add(() => {
                }, 0.5);
                timeline.add(winTimeLine);
            }
        }
    }

    protected parseFeatureGameData(data:CreepyCarnivalTwoParsedGameData):void {
        this._symbolWinStates = data.winPositions;
        this._betLineWinData = data.betWins as IBetLineWinData[];
        this._multiplier = data.multiplier;
        this._mode = data.mode;

        // #312
        this._winBelowStake = (SlotGame.api.gameClientConfiguration.belowStakeWinRestriction && (data.singleWin <= data.playedBetValue));
        CreepyCarnivalTwoInitialWinCountUp.winBelowStake = this._winBelowStake;
    }

    protected parseInitGameData(data:CreepyCarnivalTwoParsedInitData):void {
        this._counter = data.specialSymbolsLength;
        if(data.isRestoreState) {
            SlotGame.winFieldController.showWinField(data.totalWin)
        }
    }

    protected playAllNoWinSymbols(timeline:TimelineLite):void {
        this.addAllNoWinSymbolsToTimeline(timeline);
    }

    protected getNextSymbolAnimationTimeOffset():number {
        return 0.2;
    }

    protected getNextBetWinAnimationTimeOffset():number {
        return 0.3;
    }

    protected addWinCountUpToTimeline(timeline:TimelineLite):void {
        if(this._gameData!.isBigWin) {
            if(this._mode !== "FREESPIN" && this._mode !== "RESPIN_FREESPIN") {

                EventHandler.dispatchEvent(new GameEvent(CCTwoMultiplierEvents.APPLY_MULTIPLIER)); // #218
            }

            return;
        }

        let countUpStartDelay:number = GameSetting.isFastSpin ? timeline.totalDuration() : timeline.totalDuration() + 0.1; // modified fast spin delay to fix #230, later on modified in #323
        const totalWin:number = this._gameData!.totalWin,
            duration:number = this._gameData!.currentWinRatioConfig!.duration,
            countUpTimeline:TimelineLite = new TimelineLite();
        countUpTimeline.add(this._winCountUp.getCountUpAnimation(0, this._gameData!.singleWin, duration, this._multiplier, totalWin));

        if(!GameSetting.isFastSpin) {
            countUpTimeline.add(() => {
                EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));
            }, 0);
        }

        timeline.add(countUpTimeline, countUpStartDelay);

        timeline.add(() => {
            if(this._mode === "STAR_SPIN") {
                SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.SS_WIN);
            }
        }, 0);
    }

    protected abortWinPresentation():void {
        // #323
        StageManager.getLayer(CreepyCarnivalTwoGameConfig.instance.LAYERS.INITIAL_WIN_AMOUNT_BET_LINES.name).removeChildren();

        if(this._timeline && this._timeline.isActive()) {
            this._timeline.progress(1);
        }
    }

    protected stopWinPresentation(isAborted:boolean):void {
        if(this._targetCounter >= 0) {
            if(this._targetCounter > 13) {
                this._targetCounter = 13;
            }
            this._counter = this._targetCounter;
        }

        let sym:StateReelSymbol;
        while(this._winSymbols.length > 0) {
            sym = this._winSymbols.pop()!;
            sym.scale.set(1);

            sym.changeState({
                state : GameConfig.instance.SYMBOL_STATES.normal
            });
        }

        super.stopWinPresentation(isAborted);

        let item:PIXI.Sprite;

        for(let i:number = 0; i < this._animItems.length; ++i) {
            item = this._animItems[i];

            TweenLite.killTweensOf(item);
            item.visible = false;
            item.scale.set(1);
        }
        this._winTl = null;

        if(GameSetting.isFastSpin && this._gameData!.isBigWin) {
            if(this._winTimelineAdded) {
                EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));
            }
        } else {
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));
        }

        EventHandler.dispatchEvent(new GameEvent(CCTwoInitialWPEvents.WIN_PRESENTATION_ABORTED, isAborted));
        if(this._mode === "STAR_SPIN") {
            if(!this._gameData!.isBigWin) {
                EventHandler.dispatchEvent(new GameEvent(CCTwoStarSpinIntroEvents.EXIT_FROM_STAR_SPIN));
                EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {newMode : "NORMAL"}));
                this._targetCounter = 0;
                this._counter = 0;
            }
            this._counter = 0;
        }
        this._img.visible = false;
        this._winCountUp.abort(this._gameData!.singleWin, isAborted, this._gameData!.currentMultiplier, this._gameData!.isBigWin);
        if(!this._gameData!.isBigWin) {
            SlotGame.winFieldController.showWinField();
        }
    }

    protected hasWin():boolean {
        if(this._betWinsData != null && this._betWinsData.length > 0) {
            return true;
        }

        if(this._mode === "STAR_SPIN") {
            this._counter = 0;
            EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {newMode : "NORMAL"}));
            EventHandler.dispatchEvent(new GameEvent(CCTwoStarSpinIntroEvents.EXIT_FROM_STAR_SPIN));
        }
        return false;
    }

    // Todo: Remove this and move to CCTwoNoWinSymbolsWinPresentationController while updating slot game to ^0.37.53
    private onBeforeSpinStart():void {
        while(this._noWinSymbols.length > 0) {
            const symbol:StateReelSymbol = this._noWinSymbols.pop()!;

            TweenLite.fromTo(symbol, 0.5, {alpha : symbol.alpha}, {alpha : 1});
        }
    }

    private onInitResourcesLoaded(event:LoaderEvent):void {
        if(event.key != ResourcesGroupName.MAIN) {
            return;
        }

        this._img = new PIXI.Sprite(GameResources.getTextures("assets/betline_star")[0]);
        this._img.visible = false;
        this._img.anchor.set(0.5, 0.5);

        this._container.addChild(this._img);
    }

    private createRandomTrailParticles():PIXI.Sprite[] {
        let particles:any = [];
        let particleCount = 10 + Math.random() * 10;

        for(let i = 0; i < particleCount; i++) {
            let starParticle:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("assets/particle_star")[0]);
            starParticle.anchor.set(0.5);
            starParticle.scale.set(0.3 + Math.random() * 0.5);
            particles.push(starParticle);
        }

        return particles;
    }

    private positionRandomTrailParticles(particles:PIXI.Sprite[], position:number[]) {
        let symWidth:number = CreepyCarnivalTwoGameConfig.instance.SYMBOL_WIDTH;
        let symHeight:number = CreepyCarnivalTwoGameConfig.instance.SYMBOL_HEIGHT;
        let randDirectionX = (Math.random() * 2 > 1) ? 1 : -1;
        let randDirectionY = (Math.random() * 2 > 1) ? 1 : -1;
        for(let i = 0; i < particles.length; i++) {
            (particles[i]).position.set(position[0] - symWidth / 2 + symWidth * Math.random(), position[1] + randDirectionY * (symHeight * Math.random()) / 2);
            this._container.addChild(particles[i]);
        }
    }

    private animateStarTrail(trailParticles:any[]) {
        let symWidth:number = CreepyCarnivalTwoGameConfig.instance.SYMBOL_WIDTH;
        let symHeight:number = CreepyCarnivalTwoGameConfig.instance.SYMBOL_HEIGHT;
        let randDirectionY = (Math.random() * 2 > 1) ? 1 : -1;

        for(let i = 0; i < trailParticles.length; i++) {
            let travelXDist = symWidth / 4 * (1 + Math.random());
            let travelYDist = (symHeight / 5) * (Math.random() * randDirectionY);

            TweenLite.to(trailParticles[i], Math.random(), {
                x : trailParticles[i].position.x + travelXDist,
                y : trailParticles[i].position.y + travelYDist,
                alpha : 0.5,
                onComplete : () => {
                    this._container.removeChild(trailParticles[i]);
                    trailParticles[i].destroy();
                    trailParticles[i] = null;
                }
            });
        }
    }

    private playSymbolAnimation(betLineWinData:IBetLineWinData, index:number, winLineLength:number):TimelineLite {
        let WinSymbol,
            tl:TimelineLite = new TimelineLite();

        for(let i:number = 0; i < betLineWinData.nrOfSymbols; i++) {
            WinSymbol = Reels.getSymbol(i * 3 + betLineWinData.betLine[i], 0);

            if(WinSymbol === null) {
                continue;
            }

            if(this._winSymbols.indexOf(WinSymbol) === -1) {
                this._winSymbols.push(WinSymbol);
            }

            let duration:number;

            let timeForCompleteLineAnimation = this._defaultLineAnimDelay;
            if(index < this._lineAnimDelay.length - 1) {
                timeForCompleteLineAnimation = this._lineAnimDelay[index + 1];
            }
            duration = timeForCompleteLineAnimation / 5;

            let symName:string = WinSymbol.symName;

            if(symName.indexOf("L") !== -1) {
                let item:PIXI.Sprite,
                    pos:number[];

                pos = Helper.getSymbolPositions(i * 3 + betLineWinData.betLine[i], 0);

                this._winTl = new TimelineLite();

                item = this._animItems[i * 3 + betLineWinData.betLine[i]];

                item.position.set(pos[0], pos[1]);
                item.visible = true;

                item.texture = GameResources.getTextures(`${symName}/${symName}_win`)[0];
                item.alpha = 0;

                this._winTl.add(TweenLite.to(WinSymbol.scale, 0.1 * 2 / 3, {x : 0.8, y : 0.8}), 0);
                this._winTl.add(TweenLite.to(item.scale, 0.1 * 2 / 3, {x : 0.8, y : 0.8}), 0);

                this._winTl.add(TweenLite.to(item, 0.2 * 2 / 3, {alpha : 1}), 0.1 * 2 / 3);

                this._winTl.add(TweenLite.to(WinSymbol.scale, 0.2 * 2 / 3, {x : 0}), 0.1 * 2 / 3);
                this._winTl.add(TweenLite.to(item.scale, 0.2 * 2 / 3, {x : 0}), 0.1 * 2 / 3);

                this._winTl.add(TweenLite.to(WinSymbol.scale, 0.2 * 2 / 3, {x : 1.1, y : 1.1}), 0.3 * 2 / 3);
                this._winTl.add(TweenLite.to(item.scale, 0.2 * 2 / 3, {x : 1.1, y : 1.1}), 0.3 * 2 / 3);

                this._winTl.add(TweenLite.to(item, 0.2 * 2 / 3, {alpha : 0}), 0.5 * 2 / 3);

                this._winTl.add(TweenLite.to(WinSymbol.scale, 0.2 * 2 / 3, {x : 1, y : 1}), 0.48 * 2 / 3);
                this._winTl.add(TweenLite.to(item.scale, 0.2 * 2 / 3, {x : 1, y : 1}), 0.48 * 2 / 3);

                tl.add(this._winTl, i * duration);
            } else {
                tl.add(WinSymbol.changeState({
                    state : GameConfig.instance.SYMBOL_STATES.win,
                    fadeInDuration : 0
                }), i * duration);
            }
        }

        return tl;
    }

    private addTrailToStar(i:number, symId:number) {
        let particles = this.createRandomTrailParticles();
        this.positionRandomTrailParticles(particles, CCTwoHelper.getSymbolPositions(i, symId));
        this.animateStarTrail(particles);
    }

    private playStarAnimation(data:{ betLineData:IBetLineWinData, index:number, winLength:number, isStarVisible:boolean }):TimelineLite {
        const linePositions:number[][] = [];
        let canNotify:boolean = false;

        let timeLine:TimelineLite = new TimelineLite({
            onStart : () => {
                this._img.scale.set(1, 1);
                this._img.skew.set(0);
                this._img.visible = data.isStarVisible;

                // #312
                if (!this._winBelowStake) {
                    SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.SOUND_STAR_ANIMATION);
                }
            },
            onComplete : () => {
                this._img.visible = false;
                this._img.rotation = 0;

                if(canNotify) {
                    EventHandler.dispatchEvent(new GameEvent(CCTwoInitialWPEvents.STAR_ANIMATION_COMPLETED));
                }
            }
        });
        let betLineData:number[] = data.betLineData.betLine, len:number = data.betLineData.nrOfSymbols,
            sym:string = data.betLineData.symbol;

        for(let j:number = 0; j < len; j++) {
            const symId:number = betLineData[j];
            const basePosition:number[] = CCTwoHelper.getSymbolPositions(j, symId);
            linePositions.push(basePosition);
        }

        if((this._multiplier !== 5) && (this._counter < 13) && this._mode !== "STAR_SPIN") {
            if(this.HIGH_WIN_SYMS.indexOf(sym) !== -1) {
                // cords of the image where the star has to end in case of High Win Symbols.
                linePositions.push([1045, 90 - 15]);
                canNotify = true;
                this._counter++;
                this._highSym.push(sym);
            }
        }
        this._allStarCollected = false;

        for(let j:number = 1; j < linePositions.length; j++) {
            this._img.scale.set(1, 1);
            let duration:number;

            let timeForCompleteLineAnimation = 0.8 - 0.05 * data.index;
            if(timeForCompleteLineAnimation < 0.4) {
                timeForCompleteLineAnimation = 0.4;
            }

            duration = timeForCompleteLineAnimation / 5;
            if(j >= linePositions.length - 1) {
                duration *= 3;
            }

            let easeEffect:any = Linear.easeNone;
            if(j === linePositions.length - 1) {
                easeEffect = Power1.easeOut;
            }

            if(j + 1 < linePositions.length) {
                timeLine.add(TweenLite.fromTo(this._img, duration, {
                    x : linePositions[j - 1][0],
                    y : linePositions[j - 1][1],
                    rotation : ((360 / 5) * (j - 1)) * Math.PI / 180
                }, {
                    x : linePositions[j][0],
                    y : linePositions[j][1],
                    rotation : ((360 / 5) * j) * Math.PI / 180,
                    ease : easeEffect
                }), j === 0 ? 0 : (timeLine.totalDuration()));
            } else {
                timeLine.add(TweenLite.fromTo(this._img.skew, 0.2, {x : 0, y : 0}, {
                    x : -0.8, y : 0.7
                }), timeLine.totalDuration());

                timeLine.add(TweenLite.to(this._img.scale, 0.3, {
                    x : 0.3, y : 0.3
                }), timeLine.totalDuration());

                timeLine.add(TweenLite.fromTo(this._img, 0.3, {
                    x : linePositions[j - 1][0],
                    y : linePositions[j - 1][1],
                    rotation : ((360 / 5) * (j - 1)) * Math.PI / 180
                }, {
                    x : linePositions[j][0],
                    y : linePositions[j][1],
                    immediateRender : false, // added this property to fix #221 (GSAP says fromTo can be problematic)
                    rotation : ((360 / 5) * j) * Math.PI / 180,
                    ease : easeEffect
                }), (timeLine.totalDuration() - 0.3));
            }

            let symId:number = betLineData[j - 1];
            // #312
            if((j - 1) < len && !this._winBelowStake) {
                timeLine.add(
                    () => {
                        this.addTrailToStar(j - 1, symId)
                    }, (j - 1) === 0 ? 0 : "-=" + (duration - 0.05)
                );
            }
        }

        return timeLine;
    }

    private addAllNoWinSymbolsToTimeline(timeline:TimelineLite):void {
        let noWinSymbol:StateReelSymbol | null;

        for(let i:number = 0; i < this._symbolWinStates.length; i++) {
            for(let j:number = 0; j < this._symbolWinStates[i].length; j++) {
                if(this._symbolWinStates[i][j]) {
                    continue;
                }

                noWinSymbol = Reels.getSymbol(i * 3 + j, 0);
                if(noWinSymbol == null || !noWinSymbol.visible) {
                    continue;
                }

                this._noWinSymbols.push(noWinSymbol);

                timeline.add(noWinSymbol.changeState({
                    state : GameConfig.instance.SYMBOL_STATES.noWin!,
                    fadeInDuration : 0.3 // changed this duration so that betlines could start early (approximately after no win symbols have faded)
                }), 0);
            }
        }
    }

    // #323
    public showBetlineAmountInitialWin(betWins: IBetLineWinData[]): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            container: PIXI.Container = new PIXI.Container();

        if (this._winBelowStake) {
            return tl;
        }

        container.position.set(640, 360);
        container.alpha = 0;

        betWins.forEach((betWin: IBetLineWinData, idx: number) => {
            const winAmount: PIXI.Text = new PIXI.Text(betWin.multipliedAmount.toFixed(2), new PIXI.TextStyle({
                fontFamily: OpenSans.FAMILY,
                fontSize: 30,
                fontWeight: FontWeight.BOLD,
                fill: "#fff"
            }));
            let effectiveIdx: number = idx;

            if (betWins.length > 20 && (idx >= (betWins.length / 2))) {
                effectiveIdx = (idx - (betWins.length / 2));
                winAmount.x = (container.children[0] as PIXI.Text).width + 30; // #325
            }

            winAmount.y = (effectiveIdx * 40);

            if (betWins.length > 20) {
                winAmount.anchor.set(0.5, 0);
            }

            container.addChild(winAmount);
        });

        if (betWins.length > 13) {
            container.scale.set(0.65);
            container.y -= 90;
        }
        container.pivot.set(container.width / 2, container.height / 2);

        StageManager.getLayer(CreepyCarnivalTwoGameConfig.instance.LAYERS.INITIAL_WIN_AMOUNT_BET_LINES.name).addChild(container);

        tl.to(container, 0.1, {
            alpha: 1
        });
        tl.to(container, 0.5, {
            y: "-=50"
        });
        tl.to(container, 0.1, {
            alpha: 0
        });
        tl.add(() => {
            container.removeChildren();
            StageManager.getLayer(CreepyCarnivalTwoGameConfig.instance.LAYERS.INITIAL_WIN_AMOUNT_BET_LINES.name).removeChild(container);
        });

        return tl;
    }
}